<template>
  <div>
    <v-dialog
      v-model="preventDeleteDialog"
      max-width="500px"
      class="overwrite-dropzone-index"
    >
      <v-card v-if="loading">
        <Loading></Loading>
      </v-card>
      <v-card v-else>
        <v-card-title class="text-h5">Supprimer </v-card-title>
        <v-card-text>
          <p>Voulez vous vraiment supprimer l'attribut</p>
          <p>{{ itemToDelete ? itemToDelete.name : "..." }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="d-flex justify-space-between w-100">
            <BtnWhite
              btnTitle="Annuler"
              width="null"
              @clicked="abortDelete"
            ></BtnWhite>
            <BtnRed
              btnTitle="Confirmer"
              width="null"
              @clicked="confirmDelete"
            ></BtnRed>
          </div>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnRed from "./BtnRed.vue";
import BtnWhite from "./BtnWhite.vue";
import Loading from "./Loading.vue";

export default {
  name: "PreventDelete",

  components: {
    Loading,
    BtnWhite,
    BtnRed,
  },

  props: {
    dialogDelete: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    itemToDelete: {
      type: [Object, null],
      default: null,
    },
  },

  created() {
    this.preventDeleteDialog = this.dialogDelete;
  },

  watch: {
    dialogDelete(nVal) {
      this.preventDeleteDialog = nVal;
    },
  },

  data() {
    return {
      preventDeleteDialog: this.dialogDelete,
    };
  },

  methods: {
    abortDelete() {
      this.$emit("abort");
    },

    confirmDelete() {
      this.$emit("confirm", this.itemToDelete);
    },
  },
};
</script>

<style scoped></style>
